










































































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { Actions } from '@/ts/store/Constants';
import ConfirmPopup from '@/components/Admin/Panels/ConfirmPopup.vue';
import InputFieldMethods from '@/mixins/InputFieldMethods.vue';
import DateMethods from '@/mixins/DateMethods.vue';
import GroupingChart from '@/views/Admin/GroupingChart.vue';
import DemographicChart from '@/components/Charts/DemographicChart.vue';
import FlexibleTable from '@/components/Tables/FlexibleTable.vue';
import ButtonsToggle from '@/components/ButtonsToggle.vue';
import GroupingUnitItem from '@/ts/GroupingUnitItem';
import GroupingResidentItem from '@/ts/GroupingResidentItem';
import { TableViewConfig } from '@/ts/interfaces/TableConfigTypes';

@Component({
    components: {
        ConfirmPopup,
        GroupingChart,
        DemographicChart,
        FlexibleTable,
        ButtonsToggle,
    },
    computed: {
        ...mapGetters({
            confirmPopupVisibility: 'ConfirmPopup/getConfirmPopupVisibility',
        }),
    },
})

export default class Grouping extends Mixins(InputFieldMethods, DateMethods) {
    public groupingDropdown: boolean = false;
    public groupingDropdownIndex: number = -1;
    public activeTableTab: string = 'units';
    public tableTabs: any = [
        { label: this.$t('general.units', 'Units'), value: 'units' },
        { label: this.$t('general.residents', 'Residents'), value: 'residents' },
    ];
    public charts: any = [
        { label: this.$t('general.age', 'Age'), mode: 'age' },
        { label: this.$t('general.gender', 'Gender'), mode: 'gender' },
        { label: this.$t('general.interests', 'Interests'), mode: 'socialClubs' },
        { label: this.$t('general.field-of-profession', 'Field of profession'), mode: 'educations' },
    ];

    constructor() {
        super();
    }

    get columns() {
        return this.activeTableTab === 'units'
            ? [
                { name: 'id', label: this.$t('general.id', 'ID'), align: 'left', field: 'id', sortable: true, required: true },
                { name: 'project', label: this.$t('general.project', 'Project'), align: 'left', field: 'project', sortable: true },
                { name: 'titleNumber', label: this.$t('general.title-number', 'Title Number'), align: 'left', field: 'titleNumber', sortable: true },
                { name: 'vacant', label: this.$t('general.vacant', 'Vacant'), align: 'left', field: 'vacant', sortable: true },
                { name: 'address', label: this.$t('general.address', 'Address'), align: 'left', field: 'address', sortable: true },
                { name: 'residents', label: this.$t('general.residents', 'Residents'), align: 'left', field: 'residents', sortable: true },
            ]
            : [
                { name: 'id', label: this.$t('general.id', 'ID'), align: 'left', field: 'id', sortable: true, required: true },
                { name: 'name', label: this.$t('general.name', 'Name'), align: 'left', field: 'name', sortable: true },
                { name: 'address', label: this.$t('general.address', 'address'), align: 'left', field: 'address', sortable: true },
                { name: 'gender', label: this.$t('general.gender', 'Gender'), align: 'left', field: 'gender', sortable: true },
                { name: 'age', label: this.$t('general.age', 'Age'), align: 'left', field: 'age', sortable: true },
                { name: 'interests', label: this.$t('general.interests', 'Interests'), align: 'left', field: 'interests', sortable: true, filterType: 'array' },
                { name: 'educationTags', label: this.$t('general.education', 'Education') , align: 'left', field: 'educationTags', sortable: true, filterType: 'array' },
            ];
    }

    get defaultTableConfig(): TableViewConfig {
        return {
            visibleColumns: [
                'id',
                'project',
                'vacant',
                'address',
                'residents',
            ],
        };
    }

    get tableData() {
        return this.activeTableTab === 'units' ? this.groupingUnits : this.groupingResidents;
    }

    get downloadFileName(): string {
        return this.activeTableTab === 'units' ? 'Grouping-Units' : 'Grouping-Residents';
    }

    get selectType(): string {
        return this.activeTableTab === 'units' ? 'multiple' : 'none';
    }

    get groupingUnits(): GroupingUnitItem[] {
        return this.$store.getters['Groupings/getActiveGroupingUnits'];
    }

    get groupingResidents(): GroupingResidentItem[] {
        return this.$store.getters['Groupings/getActiveGroupingResidents'];
    }

    get grouping() {
        return this.$store.getters['Groupings/getCurrentGrouping'];
    }

    get demographicTenants() {
        return this.$store.getters['UnitGroupingCharts/getUnitGroupingTenantsDemographicData'];
    }


    @Watch('activeTableTab')
    public activeTableTabChanged() {

        if (this.activeTableTab === 'residents') {
            this.$store.dispatch(Actions.FETCH_GROUPING_RESIDENTS, this.grouping.id);
        }
    }

    @Watch('grouping')
    public groupingChanged() {
        if (this.grouping) {
            this.fetchTenantsData();
        }
    }

    public goBack() {
        this.$router.back();
    }

    public getVacantUnitsCount(units: any) {
        let count: number = 0;
        units.forEach((unit: any) => {
            if (unit.vacant === 'yes') {
                count++;
            }
        });
        return count;
    }

    public deleteUnitFromGrouping(unitId: number) {
        this.$store.dispatch(Actions.REMOVE_UNIT_FROM_GROUPING, { groupingId: this.grouping.id, unitId });
    }

    public editGrouping(groupingId: number) {
        this.$store.dispatch(Actions.FETCH_CURRENT_GROUPING, { groupingId, action: 'edit' });
    }

    public toggleGroupingDropdown(index: number) {
        if (index === this.groupingDropdownIndex) {
            this.closeDropDown();
        } else {
            this.groupingDropdown = this.groupingDropdownIndex !== -1 ? true : !this.groupingDropdown;
            this.groupingDropdownIndex = index;
        }
    }

    public closeDropDown() {
        this.groupingDropdown = false;
        this.groupingDropdownIndex = -1;
    }

    public fetchTenantsData() {
        this.$store.dispatch(Actions.FETCH_UNIT_GROUPING_TENANTS_DEMOGRAPHIC, this.grouping.id);
    }

    public cancel() {
        this.$router.push({ name: 'admin-groupings' });
    }


    public created() {
        window.addEventListener('click', this.closeDropDown);
        this.$store.dispatch(Actions.FETCH_CURRENT_GROUPING, {groupingId: this.$route.params.groupingId, action: 'preview'});
    }

    public beforeDestroy() {
        window.removeEventListener('click', this.closeDropDown);
    }
}
